function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M352.4 128l-95.7-64-96.3 64L64 64v320l96.4 64 96.3-64 95.7 64 95.6-64V64l-95.6 64zM168 142.4l80-53.2v281.5l-80 53.1V142.4zM264 88l80 53.4V423l-80-53.5V88zM80 94l72 47.6v281.6l-72-47.8V94zm352 281.4l-72 48.3V142.4L432 94v281.4z"
});

function SvgIosMapOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosMapOutline);
export default __webpack_public_path__ + "static/media/ios-map-outline.3c2ef071.svg";
export { ForwardRef as ReactComponent };